"use client";

import React from "react";
import { TradeItem, TradeListType } from "modules/tradeLists/model/tradeList";
import {
  ActionButtonsProps,
  CardActionButtons,
} from "modules/common/components/actions";
import { useTradeItemActions } from "modules/tradeLists/hooks/useTradeItemActions";
import { useCardDetailsModal } from "modules/cards/hooks/useCardDetailsModal";
import { FinishEnum } from "modules/cards/model/card";
import { useMultiSelectStore } from "modules/common/stores/useMultiSelectStore";
import { primaryDisplayFinish } from "modules/cards/model/finishBehavior";
import type { BinderItemsRequest } from "modules/binder/model/binder";

interface TradeItemActionButtonsProps
  extends Pick<ActionButtonsProps, "buttonClassName" | "icon"> {
  item: TradeItem;
  binderRequest?: BinderItemsRequest;
  isOwner: boolean;
  listType?: TradeListType;
  disabled?: boolean;
  className?: string;
  enableSelect?: boolean;
  onEditItem?: () => void;
  onMoveToList?: () => void;
  moveDisabled?: boolean;
  showViewDetails?: boolean;
}

export function TradeItemActionButtons({
  item,
  binderRequest,
  isOwner,
  listType,
  disabled = false,
  className,
  buttonClassName,
  icon,
  enableSelect = true,
  onEditItem,
  onMoveToList,
  moveDisabled = false,
  showViewDetails = true,
}: TradeItemActionButtonsProps) {
  const hasSelection = useMultiSelectStore((s) => s.hasSelection());
  const isDisabled = disabled || hasSelection;
  const { handleOpenCardDetailsByDataId } = useCardDetailsModal();
  const { actions } = useTradeItemActions({
    item,
    binderRequest,
    isOwner,
    listType,
    disabled: isDisabled,
    onViewCardDetails: showViewDetails
      ? () => {
          handleOpenCardDetailsByDataId(
            item.dataId,
            item.game,
            primaryDisplayFinish(item.finishes)
          );
        }
      : undefined,
    onEditItem,
    onMoveToList,
    moveDisabled,
    enableSelect,
  });

  return (
    <CardActionButtons
      actions={actions}
      disabled={isDisabled}
      className={className}
      buttonClassName={buttonClassName}
      icon={icon}
      title="Trade Item Actions"
    />
  );
}
